<template>
  <div>
    <mainone :mainonebread="mainonebread"></mainone>
    <!--table表单-->
    <div>
      <!--主list列表-->
      <div style="
          margin-top: 10px;
          background-color: #ffffff;
          border-radius: 4px;
          line-height: 40px;
          padding: 0 20px;
        ">
        <div style="line-height: 60px">
          <!--左侧名称-->
          <div style="float: left; font-size: 14px">数据列表</div>
          <!--右侧按钮-->
          <div style="float: right">
            <!--自定义按钮-点击出现弹框&点击跳转子类页面@click="routeraddrClick('/XX路由')"-->
            <!--1、点击出现弹框@click="addTanClick(XX弹框配置信息,dialogVisible = true);resetFormSenior(XXform表单)"-->
            <!--2、点击跳转子类页面@click="routeraddrClick('/XX路由')-->
            <el-button type="primary" plain @click="routeraddrClick('/fileclassifyadd')" v-if="mypowerlimits.wdfl_tj">添加
            </el-button>
            <el-button type="primary" plain @click="seeBackEvent()"
              v-if="this.$route.query.noshowplat == 1 && this.mainthreetableData.length == 0">返回上级
            </el-button>
          </div>
        </div>

        <div>
          <!--table表单-->
          <el-table ref="multipleTable" :row-class-name="tableRowClassName" :data="
            mainthreetableData.slice(
              (currentPage - lastpage) * PageSize,
              currentPage * PageSize
            )
          " style="width: 100%" min-height="900" border v-loading="loading" element-loading-text="正在飞速加载中..."
            @selection-change="handleSelectionChange" @cell-click="handleOneData">
            <!--多选框-用于用户选择性导出数据-->
            <el-table-column type="selection" width="55" v-if="mainthreeisshowset" />
            <el-table-column v-for="(mytabletitle, i) in mainthreetabletitle" :key="i" :fixed="mytabletitle.fixedstatu"
              :prop="mytabletitle.prop" :label="mytabletitle.label" :width="mytabletitle.width">
              <!--这里先通过table列表中的title值进行判断，在进行渲染展示-->
              <!--例如：status状态字段，判断最终的值是那种表现形式等-->
              <template #default="scope" v-if="
                mytabletitle.prop === 'status' ||
                mytabletitle.prop === 'source_num' ||
                mytabletitle.prop === 'set'
              ">
                <!-- 文档数量-数据渲染 -->
                <div v-if="mytabletitle.prop === 'source_num'">
                  <div :class="mypowerlimits.dyzyk ? 'mytabletext' : ''"
                    @click="mypowerlimits.dyzyk ? routeraddrClick('/printresources', scope.row) : ''">
                    <span>{{ scope.row.source_num }}</span>
                  </div>
                </div>
                <!-- 是否显示-数据渲染 -->
                <div v-if="mytabletitle.prop === 'status'">
                  <div v-if="scope.row.switchstatus === 4" id="switch">
                    <el-switch v-model="scope.row.status" active-text="开启" inactive-text="关闭" :active-value="1"
                      :inactive-value="2" active-color="#13ce66" inactive-color="#cbcbcb"
                      @change="mypowerlimits.wdfl_qy ? changeSwitchEvent(scope.row) : ''"
                      :disabled="!mypowerlimits.wdfl_qy">
                    </el-switch>
                  </div>
                </div>
              </template>
            </el-table-column>
            <!--操作&按钮-->
            <el-table-column label="操作" :width="mainthreehandle" v-if="mainthreeisshowope" prop="myoperation"
              id="operation">
              <template #default="scope">
                <!--操作：按照页面区分，且每个按钮对应相关函数-->
                <!--操作-文档分类-->
                <div v-if="mainthreetableope === 13">
                  <el-button type="primary" size="mini" v-if="scope.row.level !== '四级' && mypowerlimits.wdfl_xzxj"
                    :disabled="scope.row.status == 2" @click="routeraddrClick('/fileclassifyaddlast', scope.row)">新增下级
                  </el-button>
                  <el-button type="primary" size="mini" v-if="scope.row.level !== '一级'"
                    :disabled="scope.row.status == 2" @click="seeBackEvent(scope.row)">查看上级</el-button>
                  <el-button type="primary" size="mini" v-if="scope.row.level !== '四级'"
                    :disabled="scope.row.status == 2" @click="seeLowerEvent(scope.row)">查看下级</el-button>
                  <el-button type="primary" size="mini" @click="routeraddrClick('/fileclassifyedit', scope.row)"
                    v-if="mypowerlimits.wdfl_bj" :disabled="scope.row.status == 2">编辑
                  </el-button>
                  <el-button @click.prevent="deleteRow(scope.$index, mainthreetableData, scope.row)" type="danger"
                    size="mini" icon="el-icon-delete" v-if="mypowerlimits.wdfl_sc"></el-button>
                  <el-button type="primary" size="mini" @click="addTanClick(scope.row, 1, (dialogVisible = true))"
                    v-if="mypowerlimits.wdfl_fzwd" :disabled="scope.row.status == 2">复制文档
                  </el-button>
                  <el-button type="primary" size="mini" @click="addTanClick(scope.row, 2, (dialogVisible = true))"
                    v-if="mypowerlimits.wdfl_zywd" :disabled="scope.row.status == 2">转移文档
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <!--分页器-->
          <div class="block" style="text-align: center; margin: 30px 0">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :current-page="currentPage" :page-sizes="pageSizes" :page-size="PageSize"
              layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
            </el-pagination>
          </div>
        </div>
      </div>

      <!--弹出框-复制文档-->
      <el-dialog v-model="dialogVisible" :title="tancontent.title" :width="this.searchwidth"
        :before-close="handleCloseSenior">
        <el-form ref="seniorform" :model="seniorform" label-width="120px" :rules="seniorform_rule">
          <div style="
              max-height: 450px;
              overflow: hidden;
              overflow-y: visible;
              margin: 20px 0;
            ">
            <el-form-item label="原文档分类:">
              <div style="display: flex; flex-direction: row; flex-wrap: wrap; justify-content: space-between;">
                <div style="max-width: 200px;margin: 5px 0;">
                  <el-select v-model="seniorform.version" placeholder="请选择" disabled="true">
                    <el-option :label="getsales.cate_name" :value="String(getsales.id)"
                      v-for="(getsales, chicundex) in this.gettype" :key="chicundex"
                      @click="finduserSaleList(getsales)">
                    </el-option>
                  </el-select>
                </div>
                <div style="max-width: 200px;margin: 5px 0;">
                  <el-form-item prop="version_data">
                    <el-cascader v-model="seniorform.version_data" :options="gettypechild" :show-all-levels="false"
                      :props="{
                        value: 'id',
                        label: 'cate_name',
                        children: 'child',
                        checkStrictly: true,
                      }" clearable @change="handleChange"></el-cascader>
                  </el-form-item>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="目标文档分类:">
              <div style="display: flex; flex-direction: row; flex-wrap: wrap; justify-content: space-between;">
                <div style="max-width: 200px;margin: 5px 0;">
                  <el-form-item prop="version_change">
                    <el-select v-model="seniorform.version_change" placeholder="请选择">
                      <el-option :label="getsales1.cate_name" :value="String(getsales1.id)"
                        v-for="(getsales1, chicundex1) in gettypemubiao" :key="chicundex1"
                        @click="finduserSaleListmubiao(getsales1)"></el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div style="max-width: 200px;margin: 5px 0;">
                  <el-form-item prop="version_data_change">
                    <el-cascader v-model="seniorform.version_data_change" :options="gettypechildmubiao"
                      :show-all-levels="false" :props="{
                        value: 'id',
                        label: 'cate_name',
                        children: 'child',
                      }" clearable @change="handleChange"></el-cascader>
                  </el-form-item>
                </div>
              </div>
            </el-form-item>
          </div>
          <div style="text-align: right">
            <el-button @click="dialogVisible = false, resetFormSenior('seniorform')">取消</el-button>
            <el-button type="primary" @click="onSubmitSenior('seniorform', this.tancontent.btnapi)">{{ this.btnname }}
            </el-button>
          </div>
        </el-form>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import mainone from "@/components/Mainone";
import axios from "axios";
import { ElMessage, ElMessageBox } from "element-plus";
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "vfileclassify",
  inject: ['reload'],
  data() {
    // 原分类分类--校验
    var checkChengji = (rule, value, callback) => {
      console.log(rule, value);
      setTimeout(() => {
        callback();
      }, 500);
    };
    // 目标分类-到第四级-校验
    var checkChengjiMoji = (rule, value, callback) => {
      console.log(rule, value);
      if (value.length < 4) {
        return callback(new Error("请选择到末级第4级"));
      } else {
        setTimeout(() => {
          callback();
        }, 500);
      }
    };
    return {
      btnname: '',
      mainonebread: [
        {
          name: "教育",
        },
        {
          name: "文档管理",
        },
        {
          name: "文档分类",
          path: "/fileclassify",
        },
      ], // 当前页-【面包屑导航】
      mainthreeisshowbut: true, // 数据列表中-【添加按钮】
      mainthreeadddata: "/fileclassifyadd", //点击添加按钮-跳转路由
      mainthreeisshowset: false, // 数据列表中-复选框
      mainthreeisshowope: true, // 数据列表中-操作-根据页面显示模块（整页）
      mainthreetableope: 13, // 数据列表中-操作-根据页面显示控件（整页）
      mainthreehandle: "500", // 数据列表中-操作-宽度
      mainthreetabletitle: [
        {
          fixedstatu: false,
          prop: "id",
          label: "ID",
          width: "",
        },
        {
          fixedstatu: false,
          prop: "plat",
          label: "平台",
          width: "",
        },
        {
          fixedstatu: false,
          prop: "cate_name",
          label: "分类名称",
          width: "",
        },
        {
          fixedstatu: false,
          prop: "level",
          label: "级别",
          width: "",
        },
        {
          fixedstatu: false,
          prop: "source_num",
          label: "文档数量",
          width: "",
        },
        {
          fixedstatu: false,
          prop: "status",
          label: "是否显示",
          width: "150",
        },
        {
          fixedstatu: false,
          prop: "sort",
          label: "排序",
          width: "",
        },
      ], // 数据列表中-数据表头

      mainthreestatus: true, // 数据列表中-属于search按钮表示状态
      mainthreetableData: [], // 数据列表中-具体数据
      totalCount: 1, //数据列表中-数据总条数
      currentpage: 1, //数据列表中-数据当前页数
      lastpage: 1, //数据列表中-数据总页数（默认以20条一页）
      loading: false, //初始化-loading加载动效，默认是false关闭

      //table表单相关数据
      //获取的所有分类
      getdata: [],

      gettype: [], //原分类-配置
      gettypechild: [], // 原分类-子分类
      gettypemubiao: [], //目标分类-配置
      gettypechildmubiao: [], //目标分类-子分类
      seniorform: {
        cate_name: "",
        version: "",
        version_data: "",
        version_change: "",
        version_data_change: "",
      },
      seniorform_rule: {
        version_data: [
          {
            validator: checkChengji,
            trigger: "change",
          },
        ],
        version_change: [
          {
            required: true,
            message: "数据不能为空",
            trigger: "change",
          },
        ],
        version_data_change: [
          {
            validator: checkChengjiMoji,
            trigger: "change",
          },
        ]
      },
      chuanid: "", //存储-该条数据平台-携带参数
      currentPage: 1,
      pageSizes: [20, 50, 100],
      PageSize: 20,
      multipleSelection: [],
      thispagename: "", //通过路由获取当前页面的path值
      searchwidth: "580px",
      tancontent: {
        title: "弹框标题",
        content: {},
        btnapi: "",
      }, //弹框

      mypowerlimits: JSON.parse(localStorage.getItem("powerlimits")), //获取权限
      mytoken: localStorage.getItem("token"), //获取存储的token
      pagesdatas: [], //存储最近一次的筛选条件，供分页使用

      cunchuplat: '', //页面存储plat-前端维护字段
    };
  },
  setup() {
    const dialogVisible = ref(false);
    const handleCloseSenior = (done) => {
      done();
    };

    return {
      dialogVisible,
      handleCloseSenior,
    };
  },
  mounted() {
    //获取当前页面路由path值
    this.thispagename = this.$route.path;
  },
  methods: {
    //table表-操作中-删除按钮（函数）
    deleteRow(index, rows, getdata) {
      ElMessageBox.confirm(
        '确认删除:“' + getdata.cate_name + '”吗?',
        '提示',
        {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning',
        }
      )
        .then(() => {
          //通过Ajax向后台获取数据
          axios
            .post(
              "/manage/SharePrintSource/deleteCate",
              {
                id: getdata.id,
              },
              {
                headers: {
                  Auth: localStorage.getItem("token"),
                },
              }
            )
            .then((response) => {
              if (response.data.code === 0) {
                ElMessage({
                  type: "success",
                  message: "删除成功！",
                });
                rows.splice(index, 1);
              }
            })
            .catch(function (error) {
              // 请求失败处理
              console.log(error);
            });
        })
        .catch(() => {
          ElMessage({
            type: 'info',
            message: '取消删除',
          })
        })

    },
    //table表中-当选项发生变化是触发该函数
    handleSelectionChange(val) {
      console.log("this is:" + val);
      this.multipleSelection = val;
    },
    //分页器中-当选择条数时触发该函数
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.PageSize = val;
      this.currentPage = 1;

      //加载loading
      this.loading = true;
      axios
        .post(
          "/manage/SharePrintSource/indexCate",
          {
            pid: this.pagesdatas.pid,
            page: 1,
            page_size: val,
          },
          {
            headers: {
              Auth: localStorage.getItem("token"),
            },
          }
        )
        .then((response) => {
          this.myaxiosfunc(response.data.result);
        })
        .catch(function (error) {
          // 请求失败处理
          console.log(error);
        });
    },
    //分页器中-当选择分页时触发该函数
    handleCurrentChange(val) {
      console.log(`当前页: 第${val}页`);
      this.currentPage = val;

      //加载loading
      this.loading = true;
      //通过Ajax向后台获取数据
      axios
        .post(
          "/manage/SharePrintSource/indexCate",
          {
            pid: this.pagesdatas.pid,
            page: val,
            page_size: this.PageSize,
          },
          {
            headers: {
              Auth: localStorage.getItem("token"),
            },
          }
        )
        .then((response) => {
          this.myaxiosfunc(response.data.result);
        })
        .catch(function (error) {
          // 请求失败处理
          console.log(error);
        });
    },
    //table表中-表格带状态-可扩展
    tableRowClassName({ rowIndex }) {
      //隔行显示
      if ((rowIndex + 1) % 2 === 0) {
        return "warning-row";
      }
      return "";
    },
    //switch-按钮回调函数
    changeSwitchEvent(data) {
      axios
        .post(
          "/manage/SharePrintSource/editCate",
          {
            id: data.id,
            status: data.status,
          },
          {
            headers: {
              Auth: localStorage.getItem("token"),
            },
          }
        )
        .then((response) => {
          if (response.data.code === 0) {
            ElMessage({
              type: "success",
              message: "切换成功！",
            });
          } else {
            // 切换状态失败-复原状态
            if (data.status == 1) {
              data.status = 2;
            } else {
              data.status = 1;
            }
          }
        })
        .catch(function (error) {
          // 请求失败处理
          console.log(error);
        });
    },
    //用于下拉框-点击&选择事件-控制框是否可选择-原文档
    finduserSaleList(data) {
      if (data.child) {
        this.gettypechild = data.child;
      } else {
        this.seniorform.version_data = "";
      }
    },
    //用于下拉框-点击&选择事件-控制框是否可选择-目标文档
    finduserSaleListmubiao(data) {
      if (data.child) {
        this.gettypechildmubiao = data.child;
      } else {
        this.seniorform.version_data_change = "";
      }
    },
    //点击按钮-弹出弹框并赋值弹窗基本配置
    addTanClick(taninfo, flag) {
      this.seniorform.cate_name = taninfo.cate_name;
      if (flag == 1) {
        this.btnname = "开始复制"
        this.tancontent.title = "复制分类下文档到新分类";
        this.tancontent.btnapi = "/manage/SharePrintSource/cobyCate";
      } else {
        this.btnname = "开始转移"
        this.tancontent.title = "转移文档";
        this.tancontent.btnapi = "/manage/SharePrintSource/transferCate";
      }

      let getplat = '';
      if (taninfo.plat == '自助版') {
        getplat = 1;
      }
      if (taninfo.plat == '家庭版') {
        getplat = 2;
      }
      if (taninfo.plat == '企业版') {
        getplat = 3;
      }
      taninfo.platnum = getplat;
      this.finduserSaleList(this.gettype[taninfo.platnum - 1])
      let getversiondata = [];
      let versiondata = [];
      getversiondata = this.getidsEvent(this.gettype[taninfo.platnum - 1].child, taninfo.id, [])
      let level = '';
      if (taninfo.level == '一级') {
        level = 1
      }
      if (taninfo.level == '二级') {
        level = 2
      }
      if (taninfo.level == '三级') {
        level = 3
      }
      if (taninfo.level == '四级') {
        level = 4
      }
      if (getversiondata) {
        versiondata = getversiondata.slice(getversiondata.length - level, getversiondata.length)
      }
      this.seniorform.version = taninfo.platnum.toString();
      this.seniorform.version_data = versiondata.map(Number);
    },
    //点击进行路由页面跳转以及携带参数
    routeraddrClick(routeraddr, rowdata) {
      if (rowdata) {
        // 跳转-新增下级
        if (routeraddr == "/fileclassifyaddlast") {
          let getplat = '';
          if (rowdata.plat == '自助版') {
            getplat = 1;
          }
          if (rowdata.plat == '家庭版') {
            getplat = 2;
          }
          if (rowdata.plat == '企业版') {
            getplat = 3;
          }

          let datas = rowdata;
          datas.platnum = getplat;
          this.$router
            .push({
              path: routeraddr,
              query: datas,
            })
            .catch((error) => error);
        }
        // 跳转-编辑
        if (routeraddr == "/fileclassifyedit") {
          let getplat = '';
          if (rowdata.plat == '自助版') {
            getplat = 1;
          }
          if (rowdata.plat == '家庭版') {
            getplat = 2;
          }
          if (rowdata.plat == '企业版') {
            getplat = 3;
          }

          let datas = rowdata;
          datas.platnum = getplat;
          this.$router
            .push({
              path: routeraddr,
              query: datas,
            })
            .catch((error) => error);
        }
        // 跳转-打印资源库-传入-平台id && 分类ids
        if (routeraddr == "/printresources") {
          let getplat = '';
          if (rowdata.plat == '自助版') {
            getplat = 1;
          }
          if (rowdata.plat == '家庭版') {
            getplat = 2;
          }
          if (rowdata.plat == '企业版') {
            getplat = 3;
          }

          let datas = {
            level: rowdata.level,
            plat: getplat,
            id: rowdata.id,
          }
          if (rowdata.level == '一级') {
            datas['cate_one'] = rowdata.id;
          }
          if (rowdata.level == '二级') {
            datas['cate_two'] = rowdata.id;
          }
          if (rowdata.level == '三级') {
            datas['cate_three'] = rowdata.id;
          }
          if (rowdata.level == '四级') {
            datas['cate_four'] = rowdata.id;
          }

          this.$router
            .push({
              path: routeraddr,
              query: datas,
            })
            .catch((error) => error);
        }
      } else {
        //仅跳转
        this.$router.push(routeraddr).catch((error) => error);
      }
    },
    // 点击-查看下级信息
    seeLowerEvent(datas) {
      // console.log("查看下级信息：" + JSON.stringify(datas));
      this.$router.push({ path: '/fileclassify', query: { id: datas.id, noshowplat: 1, plat: datas.plat } }).catch((error) => error);
    },
    // 点击-查看上级信息
    seeBackEvent() {
      //返回上一级
      this.$router.back()
    },
    //导出数据
    exportDatas(tableData) {
      console.log(tableData);
    },
    // [复制文档||转移文档]弹出框-提交表单
    onSubmitSenior(formName, getbtnapi) {
      let getdatas = this.$refs[formName].model
      let oldcateid = getdatas.version_data[getdatas.version_data.length - 1];
      let newcateid = getdatas.version_data_change[getdatas.version_data_change.length - 1];
      this.$refs[formName].validate((valid) => {
        if (valid) {
          axios
            .post(getbtnapi,
              {
                old_cate_id: oldcateid,
                new_cate_id: newcateid,
              },
              {
                headers: {
                  Auth: localStorage.getItem("token"),
                },
              }
            )
            .then((response) => {
              if (response.data.code === 0) {
                this.dialogVisible = false;
                ElMessage({
                  type: "success",
                  message: response.data.message,
                  duration: 1000,
                  onClose: () => {
                    this.reload(); //刷新
                  },
                });
              }
            })
            .catch(function (error) {
              // 请求失败处理
              console.log(error);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });

    },
    //弹出框-重置
    resetFormSenior(formName) {
      this.$refs[formName].resetFields();
    },
    //获取当前windows页面信息-实时修改【弹窗】的宽度
    getwindowinfo() {
      this.sreenheight = document.documentElement.clientHeight;
      this.sreenwidth = document.documentElement.clientWidth;
      if (this.sreenwidth < 600) {
        this.searchwidth = this.sreenwidth * 0.8 + "px";
      } else {
        this.searchwidth = "580px";
      }
    },
    //提交等相关event事件函数
    //数据渲染
    myaxiosfunc(successdata) {
      var newdata = successdata.data;
      for (var i = 0; i < newdata.length; i++) {
        //该字段表示search按钮，且status为1表示启用，2表示禁用
        newdata[i].switchstatus = 4;

        // 页面存储plat-前端维护字段
        if (this.cunchuplat != '') {
          newdata[i].plat = this.cunchuplat
        }
      }
      // console.log("当前页面的data:" + JSON.stringify(newdata));
      this.mainthreetableData = newdata;
      this.totalCount = successdata.total;
      this.currentpage = successdata.current_page; //当前页面页数
      this.lastpage = successdata.last_page;
      this.loading = false;
    },
    // 递归刷id
    getidsEvent(child, contrast, ids) {
      if (child) {
        for (let i = 0; i < child.length; i++) {
          let id = child[i].id
          if (id != contrast) {
            ids.push(id)
            let result = this.getidsEvent(child[i].child, contrast, ids)
            // 递归中-数据的返回，这一步很重要！！！
            if (result) {
              return result;
            }
          } else {
            ids.push(id)
            return ids;
          }
        }
      }
    }
  },
  created() {
    if (localStorage.getItem("token") === null || !localStorage.getItem("token")) {
      this.isshow = false;
      this.$router.push("/").catch((error) => error);
    } else {
      window.addEventListener("resize", this.getwindowinfo); // 注册监听器-实时检测浏览器页面宽高
      this.getwindowinfo();

      //通过API获取配置数据-无限级分类列表
      axios
        .post(
          "/manage/SharePrintSource/sourceCateInfo",
          {
            id: -1,
          },
          {
            headers: {
              Auth: localStorage.getItem("token"),
            },
          }
        )
        .then((response) => {
          var getdata = response.data;
          this.gettype = getdata;
          this.gettypemubiao = getdata;
        })
        .catch(function (error) {
          // 请求失败处理
          console.log(error);
        });

      //加载loading
      this.loading = true;
      this.pagesdatas = {
        pid: 0,
        page: 1,
        page_size: this.PageSize,
      }
      // 路由传参
      let routerinfo = this.$route.query;
      // 父id
      if (routerinfo.id) {
        this.pagesdatas.pid = routerinfo.id
      }
      // 判断-是否需要移除-title中的平台列
      if (routerinfo.noshowplat) {
        // table表中的title移除-平台
        let getcontentdata = this.mainthreetabletitle.filter(n => n.prop != 'plat')
        this.mainthreetabletitle = getcontentdata
      }
      // 页面存储plat-前端维护字段
      if (routerinfo.plat) {
        this.cunchuplat = routerinfo.plat
      }

      //通过Ajax向后台获取数据
      axios
        .post(
          "/manage/SharePrintSource/indexCate",
          this.pagesdatas,
          {
            headers: {
              Auth: localStorage.getItem("token"),
            },
          }
        )
        .then((response) => {
          this.myaxiosfunc(response.data.result);
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  },
  components: {
    mainone,
  },
});
</script>

<style scoped>
/*局部控制-Switch按钮-按钮中显示状态文字*/
/* switch按钮款式 */
#switch :deep(.el-switch__label) {
  position: absolute;
  display: none;
  color: #fff !important;
}

/*关上时文字地位设置*/
#switch :deep(.el-switch__label--right) {
  z-index: 1;
}

/* 调整关上时文字的显示位子 */
#switch :deep(.el-switch__label--right) span {
  margin-left: 3px;
  font-size: 12px;
}

/*敞开时文字地位设置*/
#switch :deep(.el-switch__label--left) {
  z-index: 1;
}

/* 调整敞开时文字的显示位子 */
#switch :deep(.el-switch__label--left) span {
  margin-left: 15px;
  font-size: 12px;
}

/*显示文字*/
#switch :deep(.el-switch__label.is-active) {
  display: block;
}

/* 调整按钮的宽度 */
#switch :deep(.el-switch) .el-switch__core,
#switch :deep(.el-switch) .el-switch__label {
  width: 55px !important;
  margin: 0;
  padding: 5px;
}

/*操作中-按钮样式*/
.el-button--mini {
  min-height: 28px;
  padding: 0 8px;
  font-size: 12px;
  border-radius: calc(var(--el-border-radius-base) - 1px);
}

.mytabletext {
  color: var(--el-color-primary);
  cursor: pointer;
}
</style>